module.exports = {
      id: "mynews-usage",
      viewBox: "0 0 13.581 13.581",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#mynews",
      toString: function () {
        return this.url;
      }
    }